// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepForwardFilledSvg from "@ant-design/icons-svg/es/asn/StepForwardFilled";
import AntdIcon from '../components/AntdIcon';

var StepForwardFilled = function StepForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardFilledSvg
  }));
};

StepForwardFilled.displayName = 'StepForwardFilled';
export default /*#__PURE__*/React.forwardRef(StepForwardFilled);